export default "__VITE_ASSET__Zqhnn7UH__"